export const getNavigationTiming = (window: Window) => {
  if (window.performance) {
    let windowTiming =
      window.performance.timing ||
      (window.performance.getEntriesByType(
        'navigation',
      )[0] as PerformanceNavigationTiming)
    return {
      networkServer: windowTiming.responseStart - windowTiming.navigationStart,
      timeToFirstByte: windowTiming.responseStart - windowTiming.requestStart,
      domProcessing: windowTiming.domComplete - windowTiming.domLoading,
      domContentLoadedEvent:
        windowTiming.domContentLoadedEventEnd -
        windowTiming.domContentLoadedEventStart,
    }
  }
}
